export interface WarpState {
  active: boolean;
  elapsed: number;
  duration: number;
}

export const warpState: WarpState = {
  active: false,
  elapsed: 0,
  duration: 1.6,
};

export function triggerWarp() {
  warpState.active = true;
  warpState.elapsed = 0;
}
